(function(){
    'use strict';
    angular.module('Services').factory('AffiliateTableService', AffiliateTableService);
    AffiliateTableService.$inject = [
        '$filter',
        '$uibModal',
        'toastr',
        'TableLiteFactory',
        '$location',
        'AffiliateService',
        '$q',
        '$rootScope'
    ];

    function AffiliateTableService(
        $filter,
        $uibModal,
        toastr,
        TableLiteFactory,
        $location,
        AffiliateService,
        $q,
        $rootScope
    ){
        return function(partners){
            const permission = $rootScope.GlobalProfile.permissionGroup.roles.find(per=> per.code == 'ROLE_COMPANY_ADMIN' || per.code == 'ROLE_ADMIN' );
            const currency = $rootScope.GlobalProfile.company.currency;
            const buttonAction = [
                {
                    class: 'btn-success',
                    label: 'Report Approvals',
                    tooltip: 'Report Approvals',
                    onClick: function () {
                        $location.path('/affiliates-sales/approval-report');
                    }
                },
                {
                    class: 'btn-primary',
                    label: 'Create New Profile',
                    tooltip: 'Create New Profile',
                    onClick: function () {
                        $location.path('/affiliates-sales/create');
                    }
                }
            ]

            const tableData ={
                optionAddOns: {
                    buttons: permission ? buttonAction : null
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [
                    {
                        label: 'Partners',
                        viewName: 'name',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            filterBy: 'name',
                            items:[],
                            onSubmit: header => {
                               
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                            refresh: function (model){
                                const defer = $q.defer();
                                let filterItems = this.items;
                                AffiliateService.getAllcompanyPartners(
                                    data=>{
                                        angular.forEach(data.content, (item) => {
                                            filterItems.push(item);
                                        });
                                        defer.resolve();
                                      
                                    },err=>{
                                        defer.reject();
                                    },{size: 30, name: model}
                                )
                                return defer.promise;
                            }
                        },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Address',
                        viewName: 'address',
                        filterName:'addressLine1',
                        // filter: {
                        //     type: 'text',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'No. Active Client Referrals',
                        viewName: 'countReferral',
                        // filter: {
                        //     type: 'text',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'MTD Comms.',
                        viewName: 'MTDComms',
                        filterName:'id',
                        headerFn: function(){
                            sort(this.filterName);
                        }
                       
                    },
                    {
                        label: 'YTD Comms.',
                        viewName: 'YTDComms',
                        filterName:'id',
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Action',
                        viewName: 'actions'
                    }
                ],
                data: []
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AffiliateService.companyReportSummary,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.name = item.name;
                    item.acnNo = item.companyId;
                    item.address = {
                        type:'multiLine',
                        list:[item.addressLine1,item.addressLine2]
                    }
                    item.MTDComms = $filter('currency')(item.totalMonth, '') +' ' +currency;
                    item.YTDComms = $filter('currency')(item.totalYear, '') +' ' +currency;
                    item.actions = {
                        type: 'button',
                        buttons: [{
                            text: 'View',
                            tooltip:'View Partner Company.',
                            class: 'btn btn-primary',
                            action: row => {
                                $location.path('/affiliates-sales/' +item.id); //: change detailsId to id
                            },
                        },{
                            tooltip:'Remove Partner Company.',
                            class:'btn btn-danger btn-circle glyphicon glyphicon-trash',
                            action: row => {
                                removeCompany(item.id);
                            }
                        }
                    ]
                    };
                    tableData.data.push(item);
                });
            };
           
            this.tableData = tableData;

            function removeCompany(id){
                AffiliateService.deletePartnerCompany(
                    res=>{
                        toastr.success('Successfully delete!');
                        tableActions.sendRequest();
                    },
                    err=>{
                        toastr.error(err.message)
                    },
                    id
                );
            }
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/affiliateTable/AffiliateTableService.js